import { watchCountdown, countdownValues, writeCountdown } from '@theme/countdown';

class SaleeCountdownSale extends HTMLElement {
  connectedCallback() {
    this.events?.abort();
    this.events = new AbortController();
    this.products = this.querySelector('[data-sale-products]');
    this.querySelector('[data-sale-prev]')?.addEventListener('click', () => this.scrollProducts(-1), { signal: this.events.signal });
    this.querySelector('[data-sale-next]')?.addEventListener('click', () => this.scrollProducts(1), { signal: this.events.signal });
    this.deadline = new Date(this.dataset.deadline).getTime();
    this.fields = ['days', 'hours', 'minutes', 'seconds'].map((unit) => this.querySelector(`[data-countdown-${unit}]`));
    this.observeVisibility();
    this.stop = watchCountdown(this, (now) => this.updateCountdown(now));
  }

  disconnectedCallback() {
    this.stop?.();
    this.events?.abort();
    this.visibilityObserver?.disconnect();
  }

  observeVisibility() {
    if (!('IntersectionObserver' in window)) {
      this.classList.add('is-in-view');
      return;
    }
    this.visibilityObserver = new IntersectionObserver(([entry]) => {
      this.classList.toggle('is-in-view', Boolean(entry?.isIntersecting));
    }, { threshold: 0.15 });
    this.visibilityObserver.observe(this);
  }

  scrollProducts(direction) {
    const card = this.products?.querySelector('.salee-sale-card');
    if (!card || !this.products) return;
    const gap = Number.parseFloat(getComputedStyle(this.products).gap) || 16;
    this.products.scrollBy({ left: direction * (card.offsetWidth + gap), behavior: 'smooth' });
  }

  updateCountdown(now) {
    const deadline = Number.isFinite(this.deadline) ? this.deadline : 0;
    writeCountdown(this.fields, countdownValues(deadline, now));
    return deadline > now;
  }
}

if (!customElements.get('salee-countdown-sale')) customElements.define('salee-countdown-sale', SaleeCountdownSale);
